import React, { PureComponent } from 'react'
import swal from 'sweetalert'
import { Helmet } from 'react-helmet'

const swalStyles = `
    .swal-modal {
        margin:0px;
        padding:0px;
    }

    .swal-title {
        margin:0px;
        padding:0px;
    }

    .swal-text {
        font-family:  Helvetica, Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        margin:0px;
        padding:0px;
    }

    .swal-button--confirm {
        background: #28334c;
    }
`

class IOSMotionOrientationPrompt extends PureComponent {
    componentDidMount() {
        this.requestMotion(true)
    }

    requestMotion(promptForAccess) {
        if (typeof DeviceMotionEvent.requestPermission === 'function') {
            DeviceMotionEvent.requestPermission()
                .then(permissionState => {
                    const { onDevicePermissionGranted } = this.props
                    const isPermissionGranted = permissionState == 'granted'

                    onDevicePermissionGranted && onDevicePermissionGranted(isPermissionGranted)
                })
                .catch(error => {
                    if (promptForAccess) this.showPrompt(this.props.textiOS13Greater, true)
                    else console.log(error)
                })
        } else if (promptForAccess) {
            this.deviceOrientationEventTest = setTimeout(this.showPrompt, this.props.delay)
            window.addEventListener('deviceorientation', this.resetDelay)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('deviceorientation', this.resetDelay)
        this.resetDelay()
    }

    resetDelay = () => {
        clearTimeout(this.deviceOrientationEventTest)
    }

    showPrompt = (text = this.props.text, buttons = 1) => {
        const { onMotionOrientationPromptLoaded, onPromptWillShow } = this.props
        onPromptWillShow && onPromptWillShow()
        swal({
            text,
            buttons,
        }).then(requestMotion => {
            onMotionOrientationPromptLoaded && onMotionOrientationPromptLoaded()
            if ($ && $('.swal-overlay')) $('.swal-overlay').remove()
            if (requestMotion) this.requestMotion(false)
        })
    }

    render() {
        return (
            <Helmet>
                <style>{swalStyles}</style>
            </Helmet>
        )
    }
}

IOSMotionOrientationPrompt.defaultProps = {
    text:
        'Motion-based viewing is disabled. If you are using iOS 12.2, you may enable it at Settings > Safari > Motion & Orientation Access',
    textiOS13Greater: 'Motion-based viewing is disabled. Would you like to enable it now?',
    delay: 1500,
}

export default IOSMotionOrientationPrompt
